export default __webpack_public_path__ + "static/media/reg2.9049f184.webp";